export const ActionTypes = {
  SET_CITIES: 'SET_CITIES'
};
